import { NgModule } from '@angular/core';
import { LibEmploymentIconComponent } from './lib-employment-icon.component';

@NgModule({
  declarations: [LibEmploymentIconComponent],
  exports: [LibEmploymentIconComponent],
})
export class LibEmploymentIconModule {}
